// Étiquette posée sur une box verrouillée par un co-éditeur.
// Le parent (common/Box.jsx) passe en position:relative quand le verrou est actif.
// `label` distingue l'édition ('Édité par') de l'aperçu de section ('Aperçu par').
export const LockedBoxOverlay = ({ lock, label = 'Édité par' }) => (
  <div
    style={{
      position: 'absolute',
      top: 0,
      right: 0,
      backgroundColor: lock.color,
      color: '#fff',
      fontSize: 10,
      lineHeight: '14px',
      padding: '1px 6px',
      borderBottomLeftRadius: 4,
      whiteSpace: 'nowrap',
      zIndex: 10,
      pointerEvents: 'none',
    }}
  >
    {label} {lock.name}
  </div>
);

export default LockedBoxOverlay;
